import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'G-QZPN7XPRYJ',
// })
import VueGtag from 'vue-gtag'
import { version } from '../package.json'
import { datadogRum } from '@datadog/browser-rum'

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GTAG },
})

Vue.config.productionTip = false

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  },
})

datadogRum.init({
  applicationId: 'dfe50da1-3f86-48ed-882b-01a15479c8c9',
  clientToken: 'pub092e45e03e7ac705bb42f89138d2fd7c',
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'us5.datadoghq.com',
  service: 'creditodigital',
  env: process.env.NODE_ENV,
  // Specify a version number to identify the deployed version of your application in Datadog
  version: version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 80,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'allow',
})

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
